import React, { FC, useEffect, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { useSportingEventsQuery } from '../../api';
import { MinsportsFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import { revealEventsMinsports } from '../../utils/revealEvents';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const { push } = useHistory();
  const access = usePermission('directory', 'classifiers');
  const { data: { dirSportingEvents = [], count = 0 } = {} } = useSportingEventsQuery({
    variables: { skip: page, first: PER_PAGE, filter },
    fetchPolicy: 'no-cache',
  });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'info',
      label: 'Номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (info) => {
          const { id, registryNumber } = info || {};
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/sporting_event/${id}`}
                >
                  {registryNumber}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'sportsString',
      label: 'Вид спорта',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'disciplinesString',
      label: 'Дисциплины',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'ageString',
      label: 'Пол / возраст',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'organizer',
      label: 'Организатор',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'period',
      label: 'период проведения',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dirCalendar',
      label: 'Календарь',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (status) => <React.Fragment>{status.shortName}</React.Fragment>,
      },
    },

    {
      name: 'status',
      label: 'Текущий статус',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (status) => <React.Fragment>{status.name}</React.Fragment>,
      },
    },
    {
      name: 'ticket',
      label: 'Заявки',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  return (
    <MainTemplate pageName="Справочник сборных команд" url="">
      <MinsportsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Справочник сборных команд</h2>
            </React.Fragment>
          }
          data={revealEventsMinsports(dirSportingEvents)}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
